import script from "./BusinessCases.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessCases.vue?vue&type=script&setup=true&lang=js"

import "./BusinessCases.vue?vue&type=style&index=0&id=2fee76c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fee76c4"]])

export default __exports__